import { FunctionComponent } from 'react';

import { Text } from '@kanda-libs/ks-design-library';

import usePreApprovalMessage from './usePreApprovalMessage';

import { FormattedRates } from '../constants';

export interface PreApprovalMessageProps {
  rates: FormattedRates | [];
}

const PreApprovalMessage: FunctionComponent<PreApprovalMessageProps> =
  function ({ rates }) {
    const { showMessage, creditLine } = usePreApprovalMessage(rates);

    if (!showMessage) return <></>;

    return (
      <Text
        text={`Congratulations! You've been pre-approved for credit up to £${(
          creditLine / 100
        ).toLocaleString()}`}
        className="block mb-8 text-purple-500 text-16-24-em"
      />
    );
  };

export default PreApprovalMessage;
